export const environment = {
  production: true,
  apiUrl: 'https://api.aipodlab.it/api',
  siteUrl: 'https://www.aipodlab.it',
  siteName: 'AI PodLab',
  siteDescription: 'AI PodLab, dove scienza e tecnologia si incontrano in 5 minuti di idee e futuro'
};
